module.exports = __webpack_public_path__ + "img/icon-clock-light.a1c3239f.svg";